export class TableContextMetric {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "name",
            "baseName": "name",
            "type": "string",
            "format": ""
        },
        {
            "name": "sql",
            "baseName": "sql",
            "type": "string",
            "format": ""
        },
        {
            "name": "description",
            "baseName": "description",
            "type": "string",
            "format": ""
        },
        {
            "name": "share",
            "baseName": "share",
            "type": "boolean",
            "format": ""
        },
        {
            "name": "value",
            "baseName": "value",
            "type": "number",
            "format": ""
        },
        {
            "name": "addedFor",
            "baseName": "addedFor",
            "type": "Array<string>",
            "format": ""
        },
        {
            "name": "edit",
            "baseName": "edit",
            "type": "TableContextEdit",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return TableContextMetric.attributeTypeMap;
    }
    constructor() {
    }
}
